module.exports = __webpack_public_path__ + "static/media/79.0697045c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/79.jpg
// module id = 1016
// module chunks = 0